import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { Button, Menu } from 'antd'
import { IoIosArrowBack } from 'react-icons/io'
// Напряму з файлу хука, а не з `../Hooks`: індекс експортує й сам `TopMenu`
// (публічне API для довідників інших контейнерів), і вийшов би цикл імпортів
import { useListResources } from '../Hooks/useListResources'

import './TopMenu.css'

export const TopMenu = ({ current }: { current?: string | null }) => {
    current ??= null
    const navigate = useNavigate()

    // Динамічно отримуємо список довідників з ресурсів Setting.List*
    const dataSource = useListResources()

    const items = dataSource.map((item) => ({
        label: item.title,
        key: item.path,
    }))

    // Адреса береться з ресурсу, а не збирається як `/settings/<path>`: довідник
    // може жити поза цією секцією (`EXTERNAL_LIST_RESOURCES` у `useListResources`)
    const urlByPath = new Map(dataSource.map((item) => [item.path, item.pageUrl]))

    // «Назад» — на сторінку «Довідники» (`SPEC-007` §7.3, RK-14: `/settings`)
    return (
        <div style={{ alignItems: 'flex-start', display: 'flex' }}>
            <Link to="/settings" style={{ marginRight: 15 }}>
                <Button style={{ height: 57 }}>
                    <IoIosArrowBack style={{ fontSize: 24 }} />
                </Button>
            </Link>
            <div style={{ maxWidth: '100%', flexGrow: 1 }}>
                <Menu
                    onClick={({ key }: { key: string }) => {
                        navigate(urlByPath.get(key) ?? `/settings/${key}`)
                    }}
                    selectedKeys={current ? [current] : []}
                    mode="horizontal"
                    items={items}
                    className="wl-top-menu"
                />
            </div>
        </div>
    )
}
